import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
    const formRef = useRef();
    const [status, setStatus] = useState('idle'); // idle | sending | success | error

    const handleSubmit = (e) => {
        e.preventDefault();
        setStatus('sending');

        emailjs.sendForm(
            process.env.REACT_APP_EMAILJS_SERVICE_ID,
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
            formRef.current,
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        )
            .then(() => {
                setStatus('success');
                formRef.current.reset();
            })
            .catch(() => setStatus('error'));
    };

    return (
        <section id="contact" className="section-divider py-24" style={{ background: 'rgba(7,8,15,0.88)' }}>
            <div className="container max-w-5xl mx-auto px-6 lg:px-8">

                <span className="text-orange-400 text-xs tracking-widest uppercase font-medium">Contact</span>
                <h2 className="text-4xl font-bold text-white mt-3 mb-3">Get In Touch</h2>
                <p className="text-lg mb-12 max-w-xl leading-relaxed" style={{ color: 'rgba(255,255,255,0.48)' }}>
                    Have a project in mind or just want to say hello? Send me a message and I'll get back to you.
                </p>

                <form ref={formRef} onSubmit={handleSubmit} className="max-w-2xl space-y-5">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                        <div>
                            <label
                                className="block text-xs tracking-widest uppercase mb-2"
                                style={{ color: 'rgba(255,255,255,0.42)' }}
                            >
                                Name
                            </label>
                            <input
                                type="text"
                                name="from_name"
                                required
                                placeholder="Your name"
                                className="glass-input"
                            />
                        </div>
                        <div>
                            <label
                                className="block text-xs tracking-widest uppercase mb-2"
                                style={{ color: 'rgba(255,255,255,0.42)' }}
                            >
                                Email
                            </label>
                            <input
                                type="email"
                                name="from_email"
                                required
                                placeholder="your@email.com"
                                className="glass-input"
                            />
                        </div>
                    </div>

                    <div>
                        <label
                            className="block text-xs tracking-widest uppercase mb-2"
                            style={{ color: 'rgba(255,255,255,0.42)' }}
                        >
                            Message
                        </label>
                        <textarea
                            name="message"
                            required
                            rows={6}
                            placeholder="What's on your mind?"
                            className="glass-input resize-none"
                        />
                    </div>

                    <div className="flex items-center gap-6 pt-1">
                        <button
                            type="submit"
                            disabled={status === 'sending'}
                            className="glass-btn"
                        >
                            {status === 'sending' ? 'Sending...' : 'Send Message'}
                        </button>

                        {status === 'success' && (
                            <span className="text-sm tracking-wide" style={{ color: 'rgba(134,239,172,0.9)' }}>
                                Message sent!
                            </span>
                        )}
                        {status === 'error' && (
                            <span className="text-sm tracking-wide" style={{ color: 'rgba(252,165,165,0.9)' }}>
                                Something went wrong. Try again.
                            </span>
                        )}
                    </div>
                </form>

            </div>
        </section>
    );
};

export default Contact;
